// Vendor libraries
import { ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
import scrollIntoView from 'scroll-into-view-if-needed';
// Services
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/dropdown-helper.service";
import * as i2 from "@angular/common";
import * as i3 from "NewAngular/features/components/date-controls/full-year-date-range/full-year-date-range-dropdown-text.pipe";
const _c0 = ["fullYearDateRange"];
const _c1 = a0 => ({ show: a0 });
function FullYearDateRangeComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 5)(1, "input", 6);
    i0.ɵɵlistener("click", function FullYearDateRangeComponent_label_5_Template_input_click_1_listener() { const year_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.selectYear(year_r3)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 7)(3, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const year_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵattribute("scroll-id", year_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r3.startYear && !ctx_r3.endYear && ctx_r3.startYear === year_r3 || ctx_r3.startYear && ctx_r3.endYear && (ctx_r3.startYear <= year_r3 && year_r3 <= ctx_r3.endYear));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", year_r3);
} }
/**
 *
 * Full Year Date Range Component
 *
 * This component allows a user to select a year, or a range of years provided as input.
 *
 * Input Properties:
 *   rangeEndYear: The maximum year to display in the range selector (default current + 5)
 *   rangeStartYear: The minimum year to display in the range selector (default current - 10)
 *   startYear: The start year to display in the full year date range dropdown
 *   endYear: The end year to display in the full year date range dropdown
 *
 * Output Properties:
 *   dateRangeHandler: An event emitter that emits an object containing the start and end dates.
 */
export class FullYearDateRangeComponent {
    constructor(dropdownHelperService) {
        this.dropdownHelperService = dropdownHelperService;
        this.dateRangeHandler = new EventEmitter();
        this.isOpen = false;
        this.years = [];
        this.isChanged = false;
        this.dropdownHelperService = dropdownHelperService;
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.isOpen = false;
                this.submit();
            }
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement.parentElement, autoCloseHandler);
    }
    ngOnInit() {
        this.currentYear = new Date().getFullYear();
        // TODO: check for years that are too early? i.e. before 1950
        // Set start year to 1950 if not supplied
        if (!this.rangeEndYear || this.rangeEndYear < this.rangeStartYear) {
            this.rangeEndYear = this.currentYear + 5;
        }
        if (!this.rangeStartYear) {
            this.rangeStartYear = 1950;
        }
        // Set up start and end years
        for (let year = this.rangeStartYear; year < this.rangeEndYear; year += 1) {
            this.years.push(year);
        }
    }
    ngOnChanges(changes) {
        if (!this.years)
            return;
        if (changes?.startYear?.currentValue) {
            // Check if startYear is outside the valid year range
            if (!(this.startYear && this.rangeStartYear <= this.startYear && this.startYear <= this.rangeEndYear)) {
                this.startYear = null;
            }
        }
        if (changes?.startYear?.currentValue && changes?.endYear?.currentValue) {
            // Check if endYear is outside the valid year range
            if (this.startYear &&
                this.endYear &&
                (this.endYear <= this.startYear ||
                    (this.endYear < this.rangeStartYear && this.endYear > this.rangeEndYear))) {
                this.endYear = null;
            }
        }
    }
    toggleDropdown() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            // If the user already has year(s) selected then we scroll to the first year selected.
            // Otherwise, scroll to the current year
            this.scrollToYear(this.startYear ? this.startYear : this.currentYear);
        }
        else {
            this.submit();
        }
    }
    selectYear(year) {
        // No years selected
        if (!this.startYear) {
            this.startYear = year;
        }
        // Only start year is selected
        else if (this.startYear && !this.endYear) {
            if (this.startYear === year) {
                this.startYear = null;
            }
            else if (this.startYear < year) {
                this.endYear = year;
            }
            else {
                this.endYear = this.startYear;
                this.startYear = year;
            }
        }
        // Start and end years selected
        else if (this.startYear && this.endYear) {
            if (this.startYear <= year && year <= this.endYear) {
                this.startYear = null;
                this.endYear = null;
            }
            else {
                this.startYear = year;
                this.endYear = null;
            }
        }
    }
    scrollToYear(year) {
        setTimeout(() => {
            const querySelector = `.dropdown-item[scroll-id="${year}"]`;
            const target = document.querySelector(querySelector);
            if (target) {
                scrollIntoView(target, {
                    block: 'center',
                    boundary: (parent) => !parent.classList.contains('dropdown'),
                    scrollMode: 'if-needed',
                });
            }
        }, 0);
    }
    submit() {
        // No years were selected
        let newDateRange = {
            startDate: { date: null },
            endDate: { date: null },
        };
        // Only one year was selected
        if (this.startYear && !this.endYear) {
            newDateRange = {
                startDate: { date: new Date(this.startYear - 1, 11, 31) },
                endDate: { date: new Date(this.startYear, 11, 31) },
            };
        }
        // Multiple years were selected
        else if (this.startYear && this.endYear) {
            newDateRange = {
                startDate: { date: new Date(this.startYear - 1, 11, 31) },
                endDate: { date: new Date(this.endYear, 11, 31) },
            };
        }
        this.dateRangeHandler.emit(newDateRange);
    }
}
FullYearDateRangeComponent.ɵfac = function FullYearDateRangeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FullYearDateRangeComponent)(i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
FullYearDateRangeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FullYearDateRangeComponent, selectors: [["ycn-full-year-date-range"]], viewQuery: function FullYearDateRangeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, inputs: { rangeStartYear: "rangeStartYear", rangeEndYear: "rangeEndYear", startYear: "startYear", endYear: "endYear" }, outputs: { dateRangeHandler: "dateRangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 8, consts: [["fullYearDateRange", ""], [1, "form-group"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", "btn-block", "dropdown-toggle", 3, "click", "textContent"], [1, "dropdown-menu", "dropdown-menu-scrollable-xl", 3, "ngClass"], ["class", "custom-control custom-checkbox dropdown-item custom-checkbox-style1", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"]], template: function FullYearDateRangeComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1, 0)(2, "a", 2);
        i0.ɵɵpipe(3, "fullYearDateRangeDropdownText");
        i0.ɵɵlistener("click", function FullYearDateRangeComponent_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleDropdown()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, FullYearDateRangeComponent_label_5_Template, 4, 3, "label", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(3, 3, ctx.startYear, ctx.endYear));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx.isOpen));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.years);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.FullYearDateRangeDropdownTextPipe], encapsulation: 2 });
